var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttentionWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3999 7.8H6.5999V9H5.3999V7.8ZM5.3999 3H6.5999V6.6H5.3999V3ZM5.99376 0C2.68176 0 -0.000244141 2.688 -0.000244141 6C-0.000244141 9.312 2.68176 12 5.99376 12C9.31176 12 11.9998 9.312 11.9998 6C11.9998 2.688 9.31176 0 5.99376 0ZM5.99946 10.8C3.34746 10.8 1.19946 8.65201 1.19946 6C1.19946 3.348 3.34746 1.2 5.99946 1.2C8.65146 1.2 10.7995 3.348 10.7995 6C10.7995 8.65201 8.65146 10.8 5.99946 10.8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionWhite);
export default __webpack_public_path__ + "static/media/attention-white.e88b1a9402c9617e28c5bfb2685f7d76.svg";
export { ForwardRef as ReactComponent };